/**============================================================
*   [equal-height]
*   description : 高さ揃えの処理を記述
============================================================*/
document.addEventListener('DOMContentLoaded', function() {
  function equalHeight(elements) {
    const target = Array.from(document.querySelectorAll(elements));
    const heightList = [];
    target.forEach(element => {
      element.style = '';
      const height = element.clientHeight;
      heightList.push(height);
    });
    const maxHeight = Math.max.apply(null,heightList);
    target.forEach(element => {

      if(window.matchMedia('(min-width:767px)').matches) {
        element.style.height = maxHeight + 'px';
      }else{
        //sp
        element.style = '';
      }
    });
  }
  window.addEventListener('resize', function(){equalHeight('.js-equal-height')}, true);
  equalHeight('.js-equal-height');
});
